import "./aboutStyles.css";

export default function About(){

    return(
        <div className="page">
        <div className="abt">
            <div className="about">
                <h1>ABOUT US</h1>
            </div>
        <div class="square">
        <div className="atxt">          
        <p>Welcome to Lens Mind a decentralized social media app! We're thrilled to have you join us on this journey towards a more transparent, secure, and user-controlled social media platform.
            At our core, we're built on the Lens protocol, which allows us to offer a truly decentralized experience to our users. This means that you, as a user, have full ownership and control 
            over your data and content. No more worrying about your personal information being sold to advertisers or third-party companies without your consent. With our app, you have the power 
            to decide what you want to share, with whom, and when.</p>

            <p>But we didn't stop there. We also added the unique feature of meeting rooms, powered by Huddle01. With Huddle01, you can create private or public meeting rooms within the app, where 
            you can collaborate, share ideas, and connect with like-minded individuals. Whether you're a small team working on a project, a group of friends planning a trip, or a community 
            organizing a virtual event, our meeting rooms offer a safe and secure space for you to come together
             and achieve your goals.</p>
             <p>We invite you to join us on this journey and be a part of the future of social media. 
             Sign up now and experience the freedom, security, and creativity that our app has to offer.</p>
        </div>
     </div>
     </div>
     </div>
    );
}